import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type { CreateItemTemplatePayload, ItemTemplate } from "#/types/itemTemplate";

export const itemTemplateApi = {
  create: (body: CreateItemTemplatePayload): Promise<ApiResponse<ItemTemplate>> =>
    api.post("/item-template", body),
  update: (
    id: number,
    body: Partial<CreateItemTemplatePayload>
  ): Promise<ApiResponse<ItemTemplate>> => api.patch(`/item-template/${id}`, body),
  getAll: (
    params?: BaseFilterParams
  ): Promise<ApiResponse<Paginated<ItemTemplate[]>>> => api.get("/item-template", { params }),
  getById: (id: string): Promise<ApiResponse<ItemTemplate>> => api.get(`/item-template/${id}`),
  delete: (id: number): Promise<ApiResponse<void>> => api.delete(`/item-template/${id}`),
};
